import { useDisclosure } from "@chakra-ui/react";
import ClientMgt from "../clientmgt";
import { ReportModal } from "./components/ReportModal";
import { useState } from "react";
import { getAPIEndpoint } from "views/config";
import axios from "axios";
import { logger } from "views/models/logging";
import { dateSub } from "views/helpers/date";
import { formatYMD } from "views/helpers/date";
import BalanceCheck from "../balancecheck";

export function ReportMgt() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [stats, setStats] = useState([]);
    const [soldCount, setSoldCount] = useState(0);
    const [soldAmount, setSoldAmount] = useState(0.00);
    const [transCount, setTransCount] = useState(0);
    const [transCountLoading, setTransCountLoading] = useState(false);
    const [statsLoading, setStatsLoading] = useState(false);
    const [agentId, setAgentId] = useState();
    const [agentName, setAgentName] = useState();
    const [balance, setBalance] = useState(0.00);
    const [balanceLoading, setBalanceLoading] = useState(false);
    const [showReport, setShowReport] = useState(false);

    const today = formatYMD(new Date().toLocaleDateString("en-GB", { timeZone: 'Africa/Lagos' }));
    const minDate = formatYMD(dateSub(today, 7));
    const [dateVal, setDateVal] = useState(today);

    const showReportModal = (params) => {
        setAgentId(params.agentId);
        setAgentName(params.agentName);

        setShowReport(true);
    }

    const getStats = async (clientId, key) => {
        setStatsLoading(true);
        const params = {
            agentId: clientId,
            transDate: dateVal
        };

        const apiHeader = {
            headers: {
                "authorization": `Bearer ${key}`
            }
        }

        try {
            const response = await axios.post(getAPIEndpoint('stats'), params, apiHeader);
            if (response)
                processStats(response.data);
        } catch (error) {
            await logger({ task: "Get transaction stats", error: error.toString() });
        }
        setStatsLoading(false);
    }

    const getBalance = async (clientId, key) => {
        setBalanceLoading(true);
        const params = {
            agentId: clientId,
            balanceDate: dateVal
        };

        const apiHeader = {
            headers: {
                "authorization": `Bearer ${key}`
            }
        }

        try {
            const response = await axios.post(getAPIEndpoint('balance'), params, apiHeader);
            if (response) {
                const { status, data } = response.data;
                if (status === 'success' && data)
                    setBalance(parseFloat(data[0].balance));
                else
                    setBalance(0);
            }

        } catch (error) {
            await logger({ task: "Balance check", error: error.toString() });
        }
        setBalanceLoading(false);
    }

    const getTrxnCount = async (clientId, key) => {
        setTransCountLoading(true);
        const params = {
            agentId: clientId,
            transDate: dateVal
        };

        const apiHeader = {
            headers: {
                "authorization": `Bearer ${key}`
            }
        }

        try {
            const response = await axios.post(getAPIEndpoint('trxn_count'), params, apiHeader);
            if (response) {
                const { status, data } = response.data;
                if (status === 'success' && data)
                    setTransCount(data);
                else
                    setTransCount(0);
            }

        } catch (error) {
            await logger({ task: "Get transaction count", error: error.toString() });
        }
        setTransCountLoading(false);
    }

    const processStats = (results) => {
        const { status, data } = results;

        if (!(status === 'success' && data)) {
            return;
        }
        let mtnCount = 0, gloCount = 0, nineMobileCount = 0, airtelCount = 0;
        let mtnAmount = 0, gloAmount = 0, nineMobileAmount = 0, airtelAmount = 0;
        let totalCount = 1;

        const transVolume = (telco) => {
            const telcoData = data.filter(v => v.telco === telco);
            if (telcoData.length > 0) {
                return {
                    count: telcoData.map(v => v.count).reduce((sum, v) => sum + v, 0),
                    amount: telcoData.map(v => parseFloat(v.total)).reduce((sum, v) => sum + v, 0)
                };
            }
            else
                return { count: 0, amount: 0 };
        };

        if (status === 'success') {
            mtnCount = transVolume('MTN').count;
            gloCount = transVolume('Glo').count;
            nineMobileCount = transVolume('Airtel').count;
            airtelCount = transVolume('9Mobile').count;
            //......................
            mtnAmount = transVolume('MTN').amount;
            gloAmount = transVolume('Glo').amount;
            nineMobileAmount = transVolume('Airtel').amount;
            airtelAmount = transVolume('9Mobile').amount;

            totalCount = mtnCount + gloCount + nineMobileCount + airtelCount;
            setSoldAmount(mtnAmount + gloAmount + nineMobileAmount + airtelAmount);
            setSoldCount(totalCount);
        }
        else {
            setSoldCount(0);
            setSoldAmount(0);
        }

        const stats = [
            {
                telco: "MTN",
                stat: isNaN(mtnCount) ? 0 : mtnCount
            },
            {
                telco: "Glo",
                stat: isNaN(gloCount) ? 0 : gloCount
            },
            {
                telco: "Airtel",
                stat: isNaN(airtelCount) ? 0 : airtelCount
            },
            {
                telco: "9Mobile",
                stat: isNaN(nineMobileCount) ? 0 : nineMobileCount
            }
        ];
        setStats(stats);
    }

    const showReportPage = () => {
        setShowReport(false);
    }

    const reset = () => {
        setDateVal(today);
        onClose();
    }

    const clientProps = {
        showOptions: false,
        showReportBtn: true,
        showReportModal
    }

    const modalProps = {
        isOpen,
        agentId,
        agentName,
        dateVal,
        setDateVal,
        minDate,
        today,
        reset,
        transCountLoading,
        statsLoading,
        stats,
        soldCount: isNaN(soldCount) ? 0 : soldCount,
        soldAmount: isNaN(soldAmount) ? 0 : soldAmount,
        transCount: isNaN(transCount) ? 0 : transCount,
        getStats,
        getTrxnCount,
        getBalance,
        balanceLoading,
        balance
    }

    return (
        <>
            {!showReport ? <ClientMgt {...clientProps} /> : <BalanceCheck clientId={agentId} clientName={agentName} adminInvoke={true} nDays={7} showReportPage={showReportPage} />}
        </>
    )
}